import React from 'react';

interface InputWithLabelProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
  type?: 'input' | 'textarea';
  maxLength?: number;
  rows?: number;
  elementRight?: React.ReactNode;
  onBlur?: () => void;
  elementBeforeInput?: React.ReactNode;
  allowedPattern?: RegExp;
}

const InputWithLabel = ({ 
  label, 
  value, 
  onChange, 
  className = '', 
  type = 'input',
  maxLength,
  rows = 3,
  elementRight,
  onBlur,
  elementBeforeInput,
  allowedPattern
}: InputWithLabelProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    if (!allowedPattern || allowedPattern.test(newValue)) {
      onChange(newValue);
    }
  };

  return (
    <div className="border border-brand-color-3 rounded-md flex flex-row items-center justify-between">
        <div 
            className={`flex flex-col p-2 cursor-text flex-1 ${className}`}
            onClick={(e) => {
                // Focus the input/textarea when clicking anywhere in the container
                const input = e.currentTarget.querySelector('input, textarea');
                if (input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement) {
                input.focus();
                }
            }}
        >
            <div className="flex justify-between items-center">
                <label className="font-semibold text-xs text-brand-color-3 cursor-text">{label}</label>
            </div>
            
            <div className="flex flex-row items-center gap-1">
                {elementBeforeInput}
                {type === 'input' ? (
                    <input
                        type="text"
                        value={value}
                        onChange={handleChange}
                        maxLength={maxLength}
                        className="w-full bg-transparent outline-none"
                        onBlur={onBlur}
                    />
                ) : (
                    <textarea
                        value={value}
                        onChange={handleChange}
                        maxLength={maxLength}
                        rows={rows}
                        onBlur={onBlur}
                        className="w-full bg-transparent outline-none resize-none"
                    />
                )}
            </div>

            
            {maxLength && (
                <span className="text-xs text-brand-color-3 text-right mb-[-5px]">
                    {value.length}/{maxLength}
                </span>
            )}
        </div>
        {elementRight}
    </div>
  );
};

export default InputWithLabel;
